const LONG = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
const SHORT = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });

/** "2025-09-03" -> "September 3, 2025" */
export const longDate = (iso: string) => LONG.format(new Date(`${iso}T00:00:00Z`));

/** "2025-09-03" -> "Sep 3, 2025" */
export const shortDate = (iso: string) => SHORT.format(new Date(`${iso}T00:00:00Z`));
